export const routesConfig = {
  HOME: '/',
  LOGIN: '/login',
  LOGOUT: '/logout',
  RESET_PASSWORD: '/reset-password/:resetPasswordToken',
  FORGOT_PASSWORD: '/forgot-password',
  APPOINTMENTS: '/appointments',
  DASHBOARD: '/',
  CALENDAR: '/calendar',
  PATIENTS: "/patients",
  SETTINGS: "/settings",
  ADDPATIENT: "/patient",
  NEW_ADDPATIENT: "/patient/:action",
  NEW_APPOINTMENT: "/appointment",
  ADDAPPOINTMENT: "/appointment/:action"
}

export const publicPages = ['login', 'signup', 'forgot-password']
